import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useFetch } from "../../../../../hooks/Fetching";
import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import MultiLangAccordion from "../../../../../components/form/MultiLangAccordion";
import TitleWithTranslationForm from "../../../../../components/form/TitleWithTranslationForm";
import { ADD_DOCUMENT_CATEGORIES, EDIT_CATEGORIES } from "../../../../../enums/PermissionTitles";
import { DOC_CATEGORY } from "../../../../../enums/QueryKeys";
import Loader from "../../../../../components/loader/Loader";
import ErrorFullScreenMessage from "../../../../../components/fullScreenMessage/ErrorFullScreenMessage";
import UserHint from "../../../../../components/display/UserHint";
import { CLINIC_CATEGORIES } from "../../../../../enums/ApiPaths";
import PageContentWrapper from "../../../../../components/wrappers/PageContentWrapper";
import { useRedirectIfNotOwnClinic } from "../../../../../hooks/useRedirectIfNotOwnClinic";

const marginSides = 10;
export default function DocumentCategories() {
  const { id: clinicId } = useParams();
  const queryKey = DOC_CATEGORY + clinicId;

  const { data, isLoading, error, refetch } = useFetch(
    CLINIC_CATEGORIES,
    clinicId,
    queryKey
  );
  useRedirectIfNotOwnClinic(clinicId);

  const editPath = "/clinics/category/add/" + clinicId;
  const methods = useForm();

  const categories = data?.clinicCategories;
  const defaultCat = data?.defaultDocCategory;

  if (isLoading) return <Loader />;
  if (error) return <ErrorFullScreenMessage />;

  return (
    <PageContentWrapper>
      <Stack
        ml={{ xs: 0, sm: 0, md: marginSides }}
        mr={{ xs: 0, sm: 0, md: marginSides * 2 }}
      >
        <UserHint hint={"DocumentCategoryUserMessage"} />
        <FormProvider {...methods}>
          <TitleWithTranslationForm
            queryKey={queryKey}
            invalidateQueries={[queryKey]}
            refetch={refetch}
            apiPath={editPath}
            label={"AddCategory"}
            permissions={[ADD_DOCUMENT_CATEGORIES]}
          />
        </FormProvider>
        {defaultCat && (
          <MultiLangAccordion
            deletePermission={false}
            editPermission={false}
            permissions={{ edit: false, delete: false }}
            refetch={refetch}
            deleteConfirmationMessage={"DeleteCategoryConfirmationMessage"}
            deletePath={"/clinics/categories/"}
            editConfirmationMessage={"EditCategoryConfirmationMessage"}
            editPath={editPath}
            object={defaultCat}
            queryKeyDel={queryKey}
            queryKeyEdit={queryKey}
            key={defaultCat?.id}
          />
        )}
        {categories
          ?.slice()
          ?.sort((a, b) => a.id - b.id)
          ?.map((cat) => (
            <MultiLangAccordion
              key={cat.id}
              deletePermission={EDIT_CATEGORIES}
              editPermission={EDIT_CATEGORIES}
              refetch={refetch}
              deleteConfirmationMessage={"DeleteCategoryConfirmationMessage"}
              deletePath={"/clinics/categories/"}
              editConfirmationMessage={"EditCategoryConfirmationMessage"}
              editPath={editPath}
              object={cat}
              queryKeyDel={queryKey}
              queryKeyEdit={queryKey}
            />
          ))}
      </Stack>
    </PageContentWrapper>
  );
}